import { CarGoal, getAnnualReturnUsingRiskScore } from '../../../goals';
import { colorsByGoalType } from '../../../goals/colors';
import { getProgressUsingTargetAmount } from '../helpers';
import { BaseGoalConfig } from './types';

export const CAR: BaseGoalConfig<CarGoal> = {
    iconName: 'GoalCar',
    color: colorsByGoalType['CAR'].primary,
    defaultName: 'Car',
    getDescription: () =>
        'Life is a ride, so take every opportunity to enjoy it.',
    group: 'INVEST',
    blogLink: {
        description: 'See Plenty’s guide on cars',
        url: 'https://www.withplenty.com/blog/buying-a-car-what-you-need-to-know',
    },
    getAnnualReturn: getAnnualReturnUsingRiskScore,
    getProgress: (config) => getProgressUsingTargetAmount(config),
};
